module.exports = __webpack_public_path__ + "img/EmilyLogoPNG-10.19f7791f.png";